import { CrudForm } from '../shared/CrudPage';
import { subscriptionPlanService, enumEntries } from '@kss/api';
import type { SubscriptionPlan, SubscriptionPlanCreate, SubscriptionPlanFilter } from '@kss/api';

type F = {
  name: string; tier: string;
  monthlyPrice: number; yearlyPrice: number;
  maxUsers: number; maxStores: number; maxProducts: number;
  isActive: boolean;
};
const empty: F = {
  name: '', tier: '0',
  monthlyPrice: 0, yearlyPrice: 0,
  maxUsers: 1, maxStores: 1, maxProducts: 50,
  isActive: true,
};

export default function NewSubscriptionPlan() {
  return (
    <CrudForm<SubscriptionPlan, SubscriptionPlanCreate, SubscriptionPlanFilter, F>
      title="subscription plan" service={subscriptionPlanService} idKey="subscriptionPlanId"
      basePath="/panel/subscription-plans" emptyForm={empty}
      fields={[
        { key: 'name', label: 'Plan name', required: true, placeholder: 'Pro' },
        { key: 'tier', label: 'Tier', type: 'select',
          options: enumEntries('SubscriptionPlanTier').map((e) => ({ value: String(e.value), label: e.label })) },
        { key: 'monthlyPrice', label: 'Monthly price (₹)', type: 'number' },
        { key: 'yearlyPrice', label: 'Yearly price (₹)', type: 'number' },
        { key: 'maxUsers', label: 'Max users', type: 'number' },
        { key: 'maxStores', label: 'Max stores', type: 'number' },
        { key: 'maxProducts', label: 'Max products', type: 'number' },
        { key: 'isActive', label: 'Active', type: 'status' },
      ]}
      fromEntity={(r) => ({
        name: r.name ?? '', tier: String(r.tier ?? '0'),
        monthlyPrice: Number(r.monthlyPrice ?? 0),
        yearlyPrice: Number(r.yearlyPrice ?? 0),
        maxUsers: Number(r.maxUsers ?? 1),
        maxStores: Number(r.maxStores ?? 1),
        maxProducts: Number(r.maxProducts ?? 50),
        isActive: !!r.isActive,
      })}
      toEntity={(f, id) => ({
        subscriptionPlanId: id, name: f.name,
        tier: f.tier ? Number(f.tier) : undefined,
        monthlyPrice: f.monthlyPrice, yearlyPrice: f.yearlyPrice,
        maxUsers: f.maxUsers, maxStores: f.maxStores, maxProducts: f.maxProducts,
        isActive: f.isActive,
      })}
      validate={(f) => !f.name.trim() ? 'Plan name is required' : null}
    />
  );
}
